/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  CheckoutLogout.tsx
 *
 * Project Title :  Checkout
 *
 * Description    : Logout Component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H224423
 *
 * On            : Mar 23, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : E807958
 * On            : Mar 30, 2020
 * Description   : ASDS-1763
 *
*******************************************************************************/
import * as React from 'react';
import { getProperty } from '../../../utils/util';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import UserValidationAction from '../redux/actions/userDetailsActions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getForgeTokenInfo } from '../utils/util';

// export function redirectTo(url) {
//     window.location.href = url;
// }
// class CheckoutLogOut extends React.Component<any, any> {

//     getPostLogoutUrl = () => {
//         const postLogoutUrl: string = getProperty(CheckoutServiceURL.FORGE_ADS_REDIRECT_URL);
//         return postLogoutUrl + '/logout';
//     }
//     logoutUser = () => {
//         const idToken = getForgeTokenInfo('id_token');
//         const logoutUrl: string = getProperty(CheckoutServiceURL.LOGOUT_URL) ;
//         redirectTo ( logoutUrl + '?id_token_hint=' + idToken)
//          + '&state=123456789' + '&post_logout_redirect_uri=' + this.getPostLogoutUrl();
//     }
//     render () {
//     this.props.resetUserInfo();
//     this.logoutUser();
//     // localStorage.removeItem('checkoutInLocalStorage');  //APU Phase 3 - Pen testing fix - To remove access token from local storage
//     sessionStorage.removeItem('checkoutInLocalStorage');
//     window.location.assign(getProperty(CheckoutServiceURL.AEROSPACE_LOGOUT_URL));
//     return (<div />);
//     }
// }

// const mapDispatchToProps = {
//     resetUserInfo: UserValidationAction.resetUserInfo,
// };

// export default connect(null, mapDispatchToProps)(withRouter(CheckoutLogOut));

export function redirectTo(url) {
    // Check if running in a test environment
    if (process.env.NODE_ENV !== 'test') {
        window.location.href = url;
    } else {
        console.log(`Redirect to ${url}`); // Just log in test env, no actual redirect
    }
}

class CheckoutLogOut extends React.Component<any, any> {
    componentDidMount() {
        // Perform logout actions here
        this.props.resetUserInfo();
        this.logoutUser();
        sessionStorage.removeItem('checkoutInLocalStorage'); // Clear session storage
    }

    getPostLogoutUrl = () => {
        const postLogoutUrl: string = getProperty(CheckoutServiceURL.FORGE_ADS_REDIRECT_URL);
        return postLogoutUrl + '/logout';
    }

    logoutUser = () => {
        const idToken = getForgeTokenInfo('id_token');
        const logoutUrl: string = getProperty(CheckoutServiceURL.LOGOUT_URL);
        const fullLogoutUrl = `${logoutUrl}?id_token_hint=${idToken}&state=123456789&post_logout_redirect_uri=${this.getPostLogoutUrl()}`;
        redirectTo(fullLogoutUrl);
    }

    render() {
        // Render should ideally be idempotent and free of side effects
        return (<div>Logging out...</div>);
    }
}

const mapDispatchToProps = {
    resetUserInfo: UserValidationAction.resetUserInfo,
};

export default connect(null, mapDispatchToProps)(withRouter(CheckoutLogOut));
